import auth from "@/apps/auth/api";
import user from "@/apps/user/api";
import main from "@/apps/main/api";
import news from "@/apps/news/api";
import counters from "@/apps/counters/api";
import payments from "@/apps/payments/api";
import appeals from "@/apps/appeals/api";

export default {
  auth,
  user,
  main,
  news,
  counters,
  payments,
  appeals
};
